import { useAuth } from '@/hooks/useAuth';

export function AuthGate({ children }: { children: React.ReactNode }) {
  console.log("AuthGate: render start");
  const { ready } = useAuth();

  if (!ready) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary" />
      </div>
    );
  }
  return <>{children}</>;
}

export default AuthGate; 